/* ===========================================================================
   The Rich Beard · Barbershop / About / Contact.
   - Reveal por scroll (Reveal.tsx): IntersectionObserver + seguro a 2,5 s.
   - Lightbox de la galería (BarberGallery.tsx): flechas, Esc, contador.
   - Carril de video (VideoRail.tsx): flechas que se apagan en los bordes y
     reproductor de YouTube en lightbox.
   Se puede cargar varias veces (una por sección): se inicializa una sola.
=========================================================================== */
(function () {
  if (window.__trbPg) return;
  window.__trbPg = true;
  document.documentElement.classList.add('trb-pg-js');

  /* ---------------- Reveal ---------------- */
  function reveal(root) {
    var items = (root || document).querySelectorAll('.trb-pg-rv:not(.is-in)');
    if (!items.length) return;
    var show = function (el) { el.classList.add('is-in'); };
    if (!('IntersectionObserver' in window)) { items.forEach(show); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) {
      io.observe(el);
      setTimeout(function () { show(el); }, 2500);
    });
  }

  /* ---------------- Bloqueo de scroll ---------------- */
  function lock(on) { document.body.style.overflow = on ? 'hidden' : ''; }

  /* ---------------- Galería ---------------- */
  function initGallery(sec) {
    if (sec.__trbPg) return; sec.__trbPg = true;
    var btns = sec.querySelectorAll('[data-pg-open]');
    var lb = sec.querySelector('[data-pg-lb]');
    if (!lb || !btns.length) return;
    var img = lb.querySelector('[data-pg-lb-img]');
    var frame = lb.querySelector('[data-pg-lb-frame]');
    var count = lb.querySelector('[data-pg-lb-count]');
    var srcs = Array.prototype.map.call(btns, function (b) { return b.getAttribute('data-pg-full'); });
    var i = null;
    function show(n) {
      i = (n + srcs.length) % srcs.length;
      img.src = srcs[i];
      count.textContent = (i + 1) + ' / ' + srcs.length;
      frame.style.animation = 'none'; void frame.offsetWidth; frame.style.animation = '';
    }
    function open(n) { lb.hidden = false; lock(true); show(n); document.addEventListener('keydown', onKey); }
    function close() { lb.hidden = true; lock(false); i = null; document.removeEventListener('keydown', onKey); }
    function onKey(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') show(i + 1);
      if (e.key === 'ArrowLeft') show(i - 1);
    }
    btns.forEach(function (b, n) { b.addEventListener('click', function () { open(n); }); });
    lb.querySelectorAll('[data-pg-close]').forEach(function (b) { b.addEventListener('click', close); });
    lb.querySelector('[data-pg-prev]').addEventListener('click', function () { show(i - 1); });
    lb.querySelector('[data-pg-next]').addEventListener('click', function () { show(i + 1); });
  }

  /* ---------------- Carril de video ----------------
     Pestañas Long-form / Shorts y feed automático del canal (Chad, oct 2026).
     Los clics del reproductor van por delegación porque el feed reemplaza
     las tarjetas después de cargar. */
  function esc(t) { return String(t || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function initRail(sec) {
    if (sec.__trbPg) return; sec.__trbPg = true;
    var rail = sec.querySelector('[data-pg-rail]');
    var prev = sec.querySelector('[data-pg-rail-prev]');
    var next = sec.querySelector('[data-pg-rail-next]');
    var lb = sec.querySelector('[data-pg-vlb]');
    var tabs = sec.querySelectorAll('[data-pg-tab]');
    var all = sec.querySelector('[data-pg-all]');
    var allLabel = sec.querySelector('[data-pg-all-label]');
    if (!rail) return;
    var tpl = { play: (sec.querySelector('.trb-pg-vr__play') || {}).innerHTML || '' };
    var current = 'horizontal';
    function measure() {
      if (prev) prev.disabled = rail.scrollLeft < 8;
      if (next) next.disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 8;
    }
    function nudge(dir) { rail.scrollBy({ left: dir * Math.min(rail.clientWidth * 0.8, 640), behavior: 'smooth' }); }
    function count(f) { return rail.querySelectorAll('[data-format="' + f + '"]').length; }
    function setTab(f) {
      current = f;
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-pg-tab') === f ? 'true' : 'false'); });
      rail.querySelectorAll('[data-format]').forEach(function (li) {
        li.hidden = li.getAttribute('data-format') !== f;
        var rv = li.querySelector('.trb-pg-rv'); if (rv) rv.classList.add('is-in');
      });
      if (all) {
        var shorts = f === 'vertical';
        var href = shorts ? sec.getAttribute('data-link-shorts') : sec.getAttribute('data-link-long');
        var lab = shorts ? sec.getAttribute('data-all-shorts') : sec.getAttribute('data-all-long');
        if (href) all.href = href;
        if (lab && allLabel) allLabel.textContent = lab;
      }
      rail.scrollLeft = 0; measure();
    }
    function card(v, f) {
      var h = f === 'horizontal';
      var lab = h ? sec.getAttribute('data-label-long') : sec.getAttribute('data-label-short');
      var thumb = 'https://i.ytimg.com/vi/' + encodeURIComponent(v.id) + '/' + (h ? 'maxresdefault.jpg' : 'oar2.jpg');
      return '<li class="trb-pg-vr__item' + (h ? ' trb-pg-vr__item--h' : '') + '" data-format="' + f + '">' +
        '<div class="trb-pg-rv trb-pg-rv--scale is-in"><button type="button" class="trb-pg-vr__card" data-pg-video="' + esc(v.id) + '" data-pg-orient="' + f + '" aria-label="Play: ' + esc(v.title || 'video') + '">' +
        '<div class="trb-pg-vr__media"><img src="' + thumb + '" data-fb="https://i.ytimg.com/vi/' + encodeURIComponent(v.id) + '/hqdefault.jpg" alt="" loading="lazy" width="' + (h ? 534 : 300) + '" height="' + (h ? 300 : 533) + '">' +
        '<span class="trb-pg-vr__shade"></span><span class="trb-pg-vr__play">' + tpl.play + '</span>' +
        '<span class="trb-pg-eyebrow trb-pg-vr__badge">' + esc(lab) + '</span>' +
        (v.title ? '<p class="trb-pg-vr__cap">' + esc(v.title) + '</p>' : '') +
        '</div></button></div></li>';
    }
    /* La miniatura grande no existe en todos los videos nuevos: hqdefault sí. */
    rail.addEventListener('error', function (e) {
      var im = e.target; if (im.tagName !== 'IMG') return;
      var fb = im.getAttribute('data-fb') || im.src.replace(/\/(maxresdefault|oar2)\.jpg$/, '/hqdefault.jpg');
      if (fb && im.src !== fb) { im.removeAttribute('data-fb'); im.src = fb; }
    }, true);

    rail.addEventListener('scroll', measure, { passive: true });
    window.addEventListener('resize', measure);
    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });
    tabs.forEach(function (t) { t.addEventListener('click', function () { setTab(t.getAttribute('data-pg-tab')); }); });
    setTab(count('horizontal') ? 'horizontal' : 'vertical');

    var feed = sec.getAttribute('data-pg-feed');
    if (feed && window.fetch) {
      fetch(feed).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
        if (!d || !d.live || !(d.long || []).length && !(d.shorts || []).length) return;
        rail.innerHTML = (d.long || []).map(function (v) { return card(v, 'horizontal'); }).join('') +
          (d.shorts || []).map(function (v) { return card(v, 'vertical'); }).join('');
        setTab(current === 'vertical' || !count('horizontal') ? (count('vertical') ? 'vertical' : 'horizontal') : 'horizontal');
      }).catch(function () {});
    }

    if (!lb) return;
    var vframe = lb.querySelector('[data-pg-vframe]');
    var player = lb.querySelector('[data-pg-player]');
    function onKey(e) { if (e.key === 'Escape') close(); }
    function close() {
      lb.hidden = true; player.innerHTML = ''; lock(false);
      document.removeEventListener('keydown', onKey);
    }
    rail.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pg-video]'); if (!b) return;
      var id = b.getAttribute('data-pg-video');
      var h = b.getAttribute('data-pg-orient') === 'horizontal';
      vframe.classList.toggle('trb-pg-lb__vframe--h', h);
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1';
      f.title = 'The Rich Beard video';
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      f.allowFullscreen = true;
      player.innerHTML = ''; player.appendChild(f);
      lb.hidden = false; lock(true);
      document.addEventListener('keydown', onKey);
    });
    lb.querySelectorAll('[data-pg-close]').forEach(function (b) { b.addEventListener('click', close); });
  }

  function init(root) {
    root = root || document;
    reveal(root);
    root.querySelectorAll('[data-pg-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-pg-videos]').forEach(initRail);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Editor de temas: re-inicializa la sección recargada */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
